export const TICKETS_QUERY_CONTEXT_PREFIX = 'TicketsQueryContextProvider';
